module.exports = __webpack_public_path__ + "img/view-preview.b395628c.jpg";